var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2305,
    height: 1662,
    viewBox: "0 0 2305 1662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3662V1661.5H2305V21.3685L1987.95 0.9093L1722.99 11.3662L1458.53 31.3708L1294.75 67.7428L890.545 52.7394L762.824 31.3708L591.526 11.3662L355.617 0L0 11.3662Z",
    fill: "url(#paint0_linear_83_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_80",
    x1: 1152.5,
    y1: 2.86362e-7,
    x2: 1152.09,
    y2: 114.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A756B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#489F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector6.05d37ebeeb62468c0df406cf5505af2b.svg";
export { ForwardRef as ReactComponent };